<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-11">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">Ingresso</h3>
          <div class="row">
            <div class="col-md-9 mt-4">
              <!-- <label class="col-md-12">Eventos:*</label> -->
              <treeselect
                :multiple="false"
                :options="lista_eventos"
                placeholder="Selecione o evento..."
                v-model="eventos_id"
                @input="preenxerCampos()"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="card-body table-responsive">
          <b-table
            :fields="[
              'tipo',
              'lote',
              'valor',
              'obs',
              'nome_evento',
              'created_at',
              'status',
              'acoes',
            ]"
            :items="lista_ingressos"
            :per-page="perPage"
            :current-page="currentPage"
            id="perfil-table"
            class="table table-head-custom  table-vertical-center table-head-bg table-borderless text-uppercase"
            show-empty
            empty-text="Nenhum registro encontrado!"
          >
            <template #head(acoes)><span></span></template>
            <template #head(created_at)><span>data inclusão</span></template>
            <template #cell(created_at)="{ item }"
              ><span>{{ item.created_at | formatEnToBr }}</span></template
            >
            <template #cell(status)="{ item }">
              <span
                class="label label-lg label-inline px-2 pb-2 pt-3"
                :class="{
                  'label-light-success': item.status === 1,
                  'label-light-danger': item.status === 2,
                }"
              >
                {{ item.status === 1 ? "Ativo" : "Inativo" }}
              </span></template
            >
            <template #cell(acoes)="{ item }">
              <div class="text-right w-100">
                <button
                  v-show="lista_permissoes_filial.u_Ingresso"
                  @click="atualizar(item)"
                  class="btn btn-icon btn-light btn-sm mx-1"
                  v-b-tooltip.hover
                  title="Editar registro"
                >
                  <i class="far fa-edit text-primary"></i>
                </button>

                <button
                  v-show="lista_permissoes_filial.lock_Ingresso"
                  @click="confirm(item)"
                  class="btn btn-icon btn-light btn-sm mx-1"
                  v-b-tooltip.hover
                  title="Bloquear/Desbloquear registro"
                >
                  <i class="fas fa-trash text-danger"></i>
                </button>

                <button
                  v-show="lista_permissoes_filial.u_Ingresso"
                  @click="showModal(item)"
                  class="btn btn-icon btn-light btn-sm mx-1"
                  v-b-tooltip.hover
                  title="Bloquear/Desbloquear registro"
                >
                  <i class="fas fa-plus text-success"></i>
                </button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="lista_ingressos.length"
            :per-page="perPage"
            aria-controls="perfil-table"
          >
          </b-pagination>
        </div>
      </div>
    </div>
    <v-dialog v-model="modal_ingresso" max-width="900" persistent>
      <template>
        <v-card>
          <v-card-title>Novo Lote</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="form-group row">
              <div class="col-md-3">
                <label class="col-md-12">Titulo:*</label>
                <input
                  disabled
                  type="text"
                  class="form-control"
                  v-model="form.tipo"
                  placeholder="Digite o tipo do Ingresso"
                />
              </div>
              <div class="col-md-3">
                <label class="col-md-12">Tipo:*</label>
                <input
                  disabled
                  type="text"
                  class="form-control"
                  v-model="form.tipo2"
                  placeholder="Digite o tipo do Ingresso"
                />
              </div>
              <div class="col-md-3">
                <label class="col-md-12">Lote:*</label>
                <input
                  disabled
                  type="text"
                  class="form-control"
                  v-model="form.lote"
                  placeholder="Digite o lote do Ingresso"
                />
              </div>
              <div class="col-md-3">
                <label class="col-md-12">Obs:*</label>
                <input
                  disabled
                  type="text"
                  class="form-control"
                  v-model="form.obs"
                  placeholder="Digite o lote do Ingresso"
                />
              </div>

              <div class="col-md-3">
                <label class="col-md-12">Valor:*</label>
                <input
                  required
                  type="text"
                  class="form-control"
                  v-model="form.valor"
                  placeholder="Digite o Valor do Ingresso"
                  @input="valorFormat"
                  v-mask="variableWithMask"
                />
              </div>
              <div class="col-md-6 pt-1">
                <label class="col-md-12">Quantidade lote:</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="form.quantidade_lote"
                  placeholder="Quantidade de Ingresso do lote"
                />
              </div>
              <div class="row form-group col-md-12 pt-2">
              <div class="col-md-10 pull-left">
                <div class="md-radio-inline text-uppercase">
                  <label>Status:*</label>
                  <div class="space d-flex">
                    <b-form-radio
                      :inline="true"
                      value="2"
                      v-model="form.status"
                    >
                      inativo
                    </b-form-radio>
                    <b-form-radio
                      :inline="true"
                      value="1"
                      v-model="form.status"
                    >
                      ativo
                    </b-form-radio>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="modal_ingresso = false">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text @click="submitNovoLote">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import { fireAlert } from "@/core/mixins/alertMessageMixin";
import dateFormat from "@/core/mixins/dateFormat";
import EventoService from "@/core/services/evento.service";

export default {
  mixins: [fireAlert, dateFormat],

  data() {
    return {
      currentPage: 1,
      perPage: 10,
      eventos_id: EventoService.getEventoId(),
      modal_ingresso: false,
      ingresso: null,

      form: {
        tipo: null,
        tipo2: null,
        quantidade_lote :null,
        lote: null,
        valor: null,
        obs: "",
        obs2: "",
        desc1: "",
        desc2: "",
        desc3: "",
        cor: "",
        status:1,
        eventos_id:null,
        setor_id:null,
      },
      variableWithMask: "",

    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Ingressos" }]);
  },

  created() {
    this.listar_ingressos();
  },
  computed: {
    lista_eventos() {
      return EventoService.getEventos().map((cat) => ({
        id: cat.id,
        label: cat.id + " - " + cat.nome_evento,
      }));
    },
    lista_ingressos() {
      return this.$store.state.ingressos.lista_ingressos.filter((item) => {
        if (!this.eventos_id) return true;
        return (
         item["eventos_id"] == this.eventos_id)
           
           
        
      });
    },
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    mensagem_alert() {
      return this.$store.state.ingressos.mensagem_alert;
    },
  },
  methods: {
    async listar_ingressos() {
      await this.$store.dispatch("ingressos/listar_ingressos");
      this.$store.dispatch("configEmpresa/atualizar", "");
      // this.eventos_id =  this.$route.params.eventos_id
    },
    atualizar(value) {
      this.$router.push({ name: "createIngressos" });
      this.$store.dispatch("configEmpresa/atualizar", value);
    },

    async submitNovoLote() {
      this.form.valor =   parseFloat(
        this.form.valor.replace("R$", "").replace(",", ".")
      );
      this.verif = true;
      await this.$store.dispatch("ingressos/novo_lote", {form:this.form,id:this.ingresso.id});
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert,
      });
      await this.$store.dispatch("ingressos/listar_ingressos");
      this.modal_ingresso = false;

    },
    async confirm(value) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação bloqueara este PDV no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.bloquear(value);
          }
        },
      });
    },
    async bloquear(value) {
      await this.$store.dispatch("ingressos/bloquear_ingresso", value);
      this.fireAlert({
        ...this.mensagem_alert,
      });
    },
    showModal(item) {
      this.form = {

        obs2: item.obs2,


        desc1: item.desc1,
        desc2: item.desc2,
        desc3: item.desc3,
        cor: item.cor,
        status:item.status,

        eventos_id:item.eventos_id,
        setor_id:item.setor_id,

        tipo: item.tipo,
        tipo2: item.tipo2,

        obs: 1 + parseInt(item.obs.replace(/[^0-9]/g, "")) + "° LOTE",
        quantidade_lote: item.quantidade_lote,
        lote: parseInt(item.lote) + 1,
        valor: null,
      };
      this.ingresso = item;
      this.modal_ingresso = true;
    },

    preenxerCampos() {
      EventoService.setEventoId(this.eventos_id);

      this.fireAlert({
        tipo: "success",
        msg: "Selecionado Evento Global",
      });
    },
    valorFormat() {
      let pa = "";
      
      for (let i = 0; i < this.form.valor.length; i++) {
        if (i > 5) {
          pa = pa + "#";
        }
     
      }

   
      this.variableWithMask = "R$" + pa + "#,##";
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgba(167, 183, 255, 0.705);
}
</style>